import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
  footer: React.ReactNode;
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose, title, content, footer }) => {
  return (
    <Modal show={isOpen} onHide={onClose} dialogClassName="max-w-md w-full top-centered-modal">
      <Modal.Header className="py-2 px-4" closeButton={false}>
        <Modal.Title className="GraphikSemibold text-lg">{title}</Modal.Title>
        <Button
          variant="close"
          className="text-xs close-button"
          onClick={onClose} >
        </Button>
      </Modal.Header>

      <Modal.Body className="py-4 px-4">
        {content}
      </Modal.Body>

      <Modal.Footer className="py-2 px-4 gap-2">
        {footer}
      </Modal.Footer>
    </Modal>
  );
};

export default AuthModal;
